<button kendoButton #anchor [svgIcon]="icon" (click)="toggle()" fillMode="clear" size="none" aria-label="Actions">
</button>
<kendo-popup #popup [anchor]="anchor.element" *ngIf="showActions">
  <kendo-menu [vertical]="true" (select)="onSelect($event)">
    <kendo-menu-item *ngFor="let action of actions" [text]="action">
    </kendo-menu-item>
  </kendo-menu>
</kendo-popup>
<kendo-dialog *ngIf="showScheduleMeetingDialog$ | async" (close)="closeScheduleMeetingDialog()" class="shm-window"
  [maxWidth]="1900" [width]="1400" [minHeight]="300" [animation]="{ duration: 300, type: 'fade', direction: 'down' }"
  [themeColor]="'primary'">
</kendo-dialog>

<kendo-dialog *ngIf="showRequestExtensionDialog$ | async" (close)="closeRequestExtensionDialog()" class="shm-window"
  [maxWidth]="1900" [width]="700" [minHeight]="300" [animation]="{ duration: 300, type: 'fade', direction: 'down' }"
  [themeColor]="'primary'">
  <app-request-extension [dueDate]="dueDate" [evaluationName]="evaluationName" [referralSk]="referralSk"
    [evaluationSk]="evaluationSk" (closeDialog)="closeRequestExtensionDialog()"> </app-request-extension>
</kendo-dialog>

<kendo-dialog *ngIf="showCancelMeetingDialog$ | async" (close)="closeshowCancelMeetingDialog()" class="shm-window"
  [maxWidth]="1900" [width]="1400" [minHeight]="300" [animation]="{ duration: 300, type: 'fade', direction: 'down' }"
  [themeColor]="'primary'">
  <app-cancel-meeting [studentSk]="studentSk" (closeDialog)="closeshowCancelMeetingDialog()">
  </app-cancel-meeting>
</kendo-dialog>

<kendo-dialog *ngIf="showCloseRequestForReevaluationDialog$ | async" (close)="closeShowRequestForReevaluationDialog()"
  class="shm-window" [maxWidth]="1900" [width]="700" [minHeight]="300"
  [animation]="{ duration: 300, type: 'fade', direction: 'down' }" [themeColor]="'primary'">
  <app-close-request-for-reevaluation [referralSk]="referralSk" (closeDialog)="closeShowRequestForReevaluationDialog()">
  </app-close-request-for-reevaluation>
</kendo-dialog>

<app-student-related-events [outreachSk]="outreachSk" [nycIds]="nycId" [isEI]="isEi"
  (close)="closeStudentRelatedEventsDialog()" *ngIf="showStudentRelatedEventsDialog$ | async" [action]="action"
  [studentSk$]="studentSk" (closeDialog)="closeStudentRelatedEventsDialog()" [stdentDetails]="studentDetails">
</app-student-related-events>

<kendo-dialog title="Case Closing" *ngIf="showCaseClosingEventsDialog$ | async" (close)="closeCaseClosingEventsDialog()"
  [maxWidth]="1900" [width]="786" [maxHeight]="'90vh'" [minHeight]="300"
  [animation]="{ duration: 300, type: 'fade', direction: 'down' }">
  <app-case-closing [studentSk]="studentSk" (close)="closeCaseClosingEventsDialog()">
  </app-case-closing>
</kendo-dialog>

<kendo-dialog title="Request New Document" *ngIf="showRequestNewDocumentDialog$ | async" [maxWidth]="550" [width]="550"
  [minHeight]="300" [animation]="{ duration: 100, type: 'fade', direction: 'down' }">
  <app-request-new-document [studentSk]="studentSk"
    (closeDialog)="closeRequestNewDocumentDialog()"></app-request-new-document>
</kendo-dialog>

<kendo-dialog title="Request Document Re-upload" *ngIf="showRequestReUploadDialog$ | async" [maxWidth]="550"
  [width]="550" [minHeight]="300" [animation]="{ duration: 100, type: 'fade', direction: 'down' }">
  <app-request-reupload [studentSk]="studentSk" [lfEntryId]="documentData?.documentRef"
    (closeDialog)="closeRequestReUploadDialog()"></app-request-reupload>
</kendo-dialog>

<kendo-dialog title="User Event" *ngIf="showUserEventDialog$ | async" [maxWidth]="1500" [minWidth]="800" [width]="1500"
  [maxHeight]="800" [minHeight]="300" [height]="800" [animation]="{ duration: 100, type: 'fade', direction: 'down' }"
  (close)="closeUserEventDialog()">
  <events-log [studentSk]="studentSk" [isEI]="true"></events-log>
</kendo-dialog>

<div kendoDialogContainer></div>
<ng-template #reasonForRequest>
  <kendo-floatinglabel text="Reason for request*" class="k-w-full">
    <kendo-textarea rounded="large" fillMode="outline" [rows]="5"></kendo-textarea>
  </kendo-floatinglabel>
</ng-template>